export const clients = {
  breadcrumb: {
    overview: 'Klanten',
    show: 'Klantdetails',
    create: 'Nieuwe klant',
    edit: 'Klant bewerken',
    createContact: 'Nieuwe contactpersoon',
    editContact: 'Contactpersoon bewerken',
  },
  addressType: {
    'establishment unit': 'Vestigingseenheid',
    headquarters: 'Maatschappelijke zetel',
  },
  alerts: {
    errorKboInformation: 'Er liep iets mis bij het ophalen van de bedrijfsgegevens, probeer je het later opnieuw?',
    errorViesInformation: 'Er liep iets mis bij het ophalen van de bedrijfsgegevens, probeer je het later opnieuw?',
    successContactCreated: 'Je contactpersoon is succesvol aangemaakt!',
    successContactDeleted: 'Je contactpersoon is succesvol verwijderd!',
    successContactEditedOrganisation: 'Je contactpersoon is succesvol bewerkt!',
    successContactEditedPrivate: 'De klant is succesvol bewerkt!',
    successCreated: 'De klant werd succesvol aangemaakt!',
    successDeleted: 'De klant werd succesvol verwijderd!',
    successUpdated: 'De klant werd succesvol aangepast.',
  },
  card: {
    address: 'Adres',
    label: 'Opdrachtgever',
  },
  contact: 'Contactpersoon',
  create: {
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? Je klant is nog niet opgeslagen, en alle aanpassingen gaan verloren.',
    chooseType: {
      title: 'Kies type van klant',
      organisation: {
        description: 'Voeg een organisatie met contactpersoon toe',
        title: 'Organisatie',
      },
      private: {
        description: 'Voeg een particuliere klant of feitelijke vereniging toe',
        title: 'Particulier',
      },
    },
    company: {
      changeVatNumber: 'Niet wat je zoekt? Geef een ander btw-nummer in.',
      companyInformationDisclaimer:
        'Bovenstaande organisatie vonden we op basis van het btw-nummer. Extra informatie, zoals de contactgegevens, adres, ... kan je toevoegen in de volgende stap.',
      hasVatNumberLink: 'Btw-nummer?',
      noVatNumberLink: 'Geen btw-nummer?',
      companyInformationDisclaimerWithoutAddress:
        'Bovenstaande organisatie vonden we op basis van het btw-nummer. Het adres van de maatschappelijke zetel ontbreekt nog, vul je dit nog even in of vraag je dit op?',
      searchCompanyInformation: 'Opzoeken',
      switchToOtherNumber: 'Heeft je klant geen btw-nummer? <0>Klik hier om een ander nummer in te vullen.</0>',
      switchToVatNumber: 'Heeft je klant een btw-nummer? <0>Klik hier om te zoeken op btw-nummer.</0>',
    },
    next: 'Volgende',
    previous: 'Vorige',
    save: 'Opslaan',
    submit: 'Maak klant aan',
    title: 'Nieuwe klant',
    type: {
      contact: 'Contactpersoon',
      organisation: 'Organisatie',
    },
  },
  createContact: {
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? Je contactpersoon is nog niet opgeslagen.',
    submit: 'Voeg contactpersoon toe',
  },
  createEdit: {
    subsections: {
      comments: {
        description:
          'Hier kan je notities bijhouden voor jezelf, over deze klant. Denk aan een afwijkende betalingstermijn, speciale afspraken, ...',
        fieldFootnote: 'Alleen jij kan deze notitie zien.',
        fieldLabel: 'Extra notities',
        title: 'Notities',
      },
      contactAddress: 'Adres',
      customAgreement: {
        description:
          'Heb je een bestaande raamovereenkomst met jouw klant? Dan kan je dit hier aanduiden. Meer info? <a href="https://knowledge.creativeshelter.be/opdrachtgevers-en-overeenkomsten-wij-zetten-je-op-weg" target="_blank">Lees er alles over in onze Knowledge Base.</a>',
        title: 'Raamovereenkomst',
      },
      emails: {
        description:
          'Kies zelf wie welke e-mails ontvangt. Stuur je liever zelf door naar je klant? Dan ontvang jij de e-mail met de nodige bestanden.',
        title: 'E-mails',
      },
      personalInfo: 'Persoonlijke gegevens',
    },
  },
  customAgreementDialog: {
    cancel: 'Neen, ga terug',
    description:
      'Bevestig enkel als je met deze klant al een getekende overeenkomst hebt. Wij sturen je hierna een e-mail om de overeenkomst na te lezen. Waarom? Wij dienen namelijk mee in de overeenkomst te stappen. Meer info? Lees <a href="https://knowledge.creativeshelter.be/opdrachtgevers-en-overeenkomsten-wij-zetten-je-op-weg" target="_blank">hier</a>.',
    submit: 'Ja, ik heb een getekende overeenkomst',
    title: 'Opgelet!',
  },
  detail: {
    contacts: {
      add: 'Contactpersoon toevoegen',
      columns: {
        email: 'E-mailadres',
        name: 'Naam',
        phoneNumber: 'Telefoonnummer',
      },
      delete: {
        description: 'Ben je zeker dat je contactpersoon "{{name}}" wilt verwijderen?',
        submit: 'Verwijder contactpersoon',
        title: 'Verwijder contactpersoon',
      },
      moreEmails: 'En nog {{amount}} andere',
      rowActions: {
        duplicate: 'Kopieer',
      },
      selfEmail: '{{email}} (jijzelf)',
      title: 'Contactpersonen ({{amount}})',
    },
    info: {
      creditsafe: {
        creditRating: {
          label: 'Kredietwaardigheid',
          tooltip:
            'Dat geeft je inzichten in de financiën van je opdrachtgever. Het is geen garantie of je factuur wel of niet betaald wordt, maar zo weet je wel hoe ze het doen op financieel vlak. Lees er meer over in onze <faqLink>Knowledge Base</faqLink>.',
        },
        score: {
          A: {
            text: 'Geen risico',
          },
          B: {
            text: 'Laag risico',
          },
          C: {
            text: 'Gemiddeld risico',
          },
          D: {
            text: 'Hoog risico op onbetaalde facturen',
          },
          '?': {
            text: 'Geen informatie',
          },
        },
        status: {
          Error: 'De kredietscore kon niet opgehaald worden.',
          NotFetched: 'Kredietscore wordt opgehaald.',
        },
      },
      edit: {
        action: 'Organisatie bewerken',
      },
      refreshVatInformation: {
        ariaLabel: 'Bedrijfsgegevens vernieuwen',
        lastUpdated: '{{timeAgo}} geüpdatet uit de KBO',
        tooltip: {
          notRefreshable:
            'Haal de nieuwste gegevens van je klant op uit de <kboLink>Kruispuntbank van Ondernemingen</kboLink>.<br/>(Alleen mogelijk als de gegevens ouder zijn dan 7 dagen.)',
          refreshable: 'Haal de nieuwste gegevens van je klant op uit de <kboLink>Kruispuntbank van Ondernemingen</kboLink>.',
        },
      },
    },
    invoices: {
      title: 'Facturen',
      titleWithCount: 'Facturen ({{amount}})',
    },
  },
  editClient: {
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? De aanpassingen aan je klant zijn niet opgeslagen.',
  },
  editContact: {
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? De aanpassingen aan je contactpersoon zijn niet opgeslagen.',
  },
  fields: {
    address: {
      label: 'Adres',
    },
    city: {
      label: 'Gemeente',
    },
    companyName: {
      label: 'Bedrijfsnaam',
    },
    countryCode: {
      groups: {
        europe: 'Europa',
        europeanUnion: 'Europese Unie',
        international: 'Internationaal',
      },
      label: 'Land',
      placeholder: 'Selecteer een land...',
    },
    customAgreement: {
      label: 'Ik heb al een bestaande overeenkomst met deze klant.',
      tooltip: 'Afspraken zoals een prijsofferte, telefonische- en/of e-mailbevestiging vallen hier niet onder.',
    },
    emailAddresses: {
      addReceiver: 'Extra ontvanger toevoegen',
      addSelf: 'Zelf versturen',
      invoicesAndCreditNotes: "Facturen en creditnota's",
      label: 'E-mailadres',
      paymentReminders: 'Betalingsherinneringen',
      placeholder: 'Vul het e-mailadres in',
      peppolDisclaimer: "Facturen en creditnota's worden via het Peppol-netwerk verzonden voor deze klant.",
      quotations: 'Offertes',
    },
    enterpriseNumber: {
      label: 'Btw- of ondernemingsnummer',
    },
    firstName: {
      label: 'Voornaam',
      placeholder: 'Voornaam',
    },
    function: {
      label: 'Functie',
      placeholder: 'Functie',
    },
    lang: {
      label: 'Taal',
    },
    lastName: {
      label: 'Achternaam',
      placeholder: 'Achternaam',
    },
    number: {
      label: 'Huisnummer',
    },
    organisationName: {
      add: 'Feitelijke vereniging',
      label: 'Naam organisatie',
      tooltip: 'Is je klant een feitelijke organisatie, vul dan hier de organisatie naam in',
    },
    otherNumber: {
      label: 'Ander nummer',
      placeholder: 'Ander nummer',
    },
    street: {
      label: 'Straat',
    },
    telephone: {
      label: 'Telefoonnummer',
      placeholder: 'Telefoonnummer',
    },
    useOrganisationAddress: {
      label: 'Gebruik het adres van de organisatie',
    },
    userComments: {
      placeholder: 'Opmerkingen voor jezelf of voor Creative Shelter.',
    },
    vatNumber: {
      label: 'Btw-nummer',
    },
    vatOrOtherNumber: {
      label: 'Btw- of ander type nummer',
    },
    zipcode: {
      label: 'Postcode',
    },
  },
  header: {
    actionBlock: {
      button: 'Klant aanmaken',
    },
    title: 'Klanten',
  },
  overview: {
    columns: {
      contacts: 'Contactpersonen',
      name: 'Naam',
      type: 'Klant type',
      vatOrOtherNumber: 'Btw- of ander type nummer',
    },
    delete: {
      description: 'Ben je zeker dat je de klant ({{name}}) wilt verwijderen?',
      submit: 'Verwijder klant',
      title: 'Klant verwijderen',
    },
    moreContacts: 'En nog {{amount}} andere',
    vat: {
      mailTooltip: 'Deze onderneming is nog niet aangesloten op het Peppol-netwerk. Daardoor werd de factuur via mail verstuurd',
      peppolTooltip: "Deze onderneming is aangesloten op het Peppol-netwerk. Facturen en creditnota's worden via Peppol verstuurd.",
    },
    rowActions: {
      addContact: 'Voeg contactpersoon toe',
      view: 'Bekijk',
    },
  },
  peppol: {
    status: {
      active: 'Actief',
      error: 'Het Peppol ID van deze klant kon niet opgehaald worden.',
      label: 'Peppol',
      notRegistered: 'Nog niet geregistreerd',
      pending: 'Peppol ID ophalen...',
      tooltip: {
        active:
          "Als je klant actief is op Peppol, worden facturen en creditnota's verstuurd via het Peppol-netwerk. Lees er meer over in <faqLink href='https://www.creativeshelter.be/knowledge-hub/sturen-jullie-facturen-via-peppol-mercuriusplatform-e-invoicing'>onze Knowledge Base</faqLink>.",
        notRegistered: 'Je klant is nog niet geregistreerd op Peppol. Daarom versturen we facturen voorlopig via e-mail.',
      },
    },
  },
  type: {
    organisation: 'Organisatie',
    private: 'Particulier',
  },
};
